export default class GeneralTypes {
  title?: string;
  roundTripCodeBase?: string;
  roundTripCodeDeparture?: string;
  worldPart1?: string;
  worldPart2?: string;
  worldPart3?: string;
  worldPart4?: string;
  worldPart5?: string;
  worldPart6?: string;
  worldPart7?: string;
  country1?: string;
  country2?: string;
  country3?: string;
  country4?: string;
  country5?: string;
  country6?: string;
  country7?: string;
  country8?: string;
  country9?: string;
  daysToDeparture?: number;
  departureDate?: string;
  travelType1?: string;
  travelType2?: string;
  travelType3?: string;
  travelType4?: string;
  travelType5?: string;
  travelType6?: string;
  travelType7?: string;
  travelType8?: string;
}
